import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  IconButton,
  CircularProgress,
  Divider,
  Paper,
  useTheme,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import axios from "axios";
import Cookies from "js-cookie";
import useNotification from "../common/Notification";
import { useNavigate } from "react-router-dom";
import base_url from "../../constants";
import { blue } from "@mui/material/colors";

const EmailTemplateList = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const notify = useNotification();
  const userId = Cookies.get("userId");
  const userRole = Cookies.get("userRole")?.split(",")[0];
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const response = await axios.get(base_url+
        "/email-template/getbyroleanduserid",
        {
          params: {
            user_id: userId,
            role: userRole,
          },
        }
      );
      setTemplates(response.data.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
      notify("Failed to fetch templates", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTemplate = async (templateId) => {
    try {
      await axios.post(base_url+"/email-template/delete", {
        template_id: templateId,
        user_id: userId,
        role: userRole,
      });
      notify("Template deleted successfully", "success");
      fetchTemplates();
    } catch (error) {
      console.error("Error deleting template:", error);
      notify("Failed to delete template", "error");
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant='h6'  sx={{ mb: 4, mt: 3, color : 'primary.main', backgroundColor:blue[50], px:2, width: 'fit-content', py:1, borderRadius:2, fontWeight:'bold'}}>
        Email Templates
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/email/templates/create")}
        >
          Create New
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : templates.length === 0 ? (
        <Paper sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h6">No templates found</Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Click the "Create New" button to add your first template.
          </Typography>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {templates.map((template) => (
            <Grid item xs={12} sm={6} md={4} key={template.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "box-shadow 0.3s",
                  "&:hover": { boxShadow: 3 },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {template.template_title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mb: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {template.template}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      Created: {formatDate(template.created_at)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Updated: {formatDate(template.updated_at)}
                    </Typography>
                  </Box>
                </CardContent>
                <CardActions sx={{ justifyContent: "flex-end" }}>
                  {/* <IconButton
                    aria-label="view"
                    title="View"
                    onClick={() => navigate(`/templates/view/${template.id}`)}
                  >
                    <InfoIcon color="info" />
                  </IconButton> */}
                  <IconButton
                    aria-label="edit"
                    title="Edit"
                    onClick={() => navigate(`/templates/edit/${template.id}`,{
    state: { templateData: template },
  })}
                  >
                    <EditIcon color="primary" />
                  </IconButton>
                  <IconButton
                    aria-label="delete"
                    title="Delete"
                    onClick={() => handleDeleteTemplate(template.id)}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default EmailTemplateList;
